export enum ManifestApiErrorTypes {
  CreateManifestError,
  LoadManifestsError,
  ManifestNotFoundError,
}

export class ManifestApiError {
  constructor(public type: ManifestApiErrorTypes, public error: Error) {}
}
